module.exports = __webpack_public_path__ + "static/media/blue.7e72536b.png";